import {Injectable, QueryList} from '@angular/core';
import {UserIdService} from '@spartacus/core';
import {Observable, of, Subscription} from 'rxjs';
import {catchError, concatMap, distinctUntilChanged, map, switchMap, take} from 'rxjs/operators';

import {AimoCategory, AimoCategoryHierarchy, AimoFacet, AimoFacetValue} from '../../model/product.model';

import {AimoCategoryConnector} from './aimo-category.connector';
import {AimoSearchConfig} from "../../model/misc.model";
import {AimoProductSearchConnector} from "../product/search/aimo-product-search.connector";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";

@Injectable({
    providedIn: 'root',
})
export class AimoCategoryService {
    constructor(
        protected categoryConnector: AimoCategoryConnector,
        protected productSearchConnector: AimoProductSearchConnector,
        protected userIdService: UserIdService,
    ) {
    }

    getCategoryById(categoryId: string): Observable<AimoCategory> {
        return this.userIdService.takeUserId().pipe(
            distinctUntilChanged(),
            take(1),
            switchMap((userId) => this.categoryConnector.getCategoryById(userId, categoryId)),
            catchError(() => of(undefined)),
        );
    }

    getCategoryPathById(categoryId: string): Observable<string> {
        return this.userIdService.takeUserId().pipe(
            distinctUntilChanged(),
            take(1),
            switchMap((userId) => this.categoryConnector.getCategoryPathById(userId, categoryId)),
            catchError(() => of(undefined)),
        );
    }

    getCategoryHierarchyById(categoryId: string): Observable<AimoCategoryHierarchy> {
        return this.userIdService.takeUserId().pipe(
            distinctUntilChanged(),
            take(1),
            concatMap((userId) => this.categoryConnector.getCategoryHierarchyById(userId, categoryId)),
            catchError(() => of(undefined)),
        );
    }

    categoryCache = [];

    getCategory(query: string): Observable<AimoFacetValue[]> {
        if (this.categoryCache[query]) {
            return this.categoryCache[query];
        }
        const result = this.productSearchConnector.search(query, {
            suggestiveMode: true,
            pageSize: 0
        } as AimoSearchConfig)
            .pipe(
                map(s => s.facets
                    .filter((f: AimoFacet) => f.code === 'category')
                    .flatMap((f: AimoFacet) => f.values)),
            );
        this.categoryCache[query] = result;
        return result;
    }

    closePopovers(popovers: QueryList<NgbPopover>, addedPopOvers: any[], subscriptions: Subscription) {
        popovers.forEach((popover) => {
            if (!addedPopOvers.includes(popover)) {
                subscriptions.add(popover.shown.subscribe(() => {
                    popovers.forEach((p) => {
                        if (p !== popover && p.isOpen()) {
                            p.close();
                        }
                    });
                }));
                addedPopOvers.push(popover);
            }
        });
    }
}
